import { EMAIL_UPDATE } from './reduxConstant';
import { createReducer } from '../../../../App/common/utilities/reducerUtils';

const initialState = {
  email: { message: '', code: '', email: '', setAsUsername: false },
};

const emailUpdate = (state, payload) => {
  let email = payload.email;
  return { ...state, email: { ...email } };
};

export default createReducer(initialState, {
  [EMAIL_UPDATE]: emailUpdate,
});
